export const FAQ_HOME = [
  {
    q: "Qu'est-ce qu'une carte digitale Noveocard ?",
    a: "Une carte PVC premium 86 × 54 mm, personnalisée à votre image, équipée d'une puce NFC. Quand un client approche son smartphone de la carte, il accède instantanément à votre page digitale : avis Google, Instagram, WhatsApp, menu, itinéraire… La carte est la porte d'entrée vers votre univers digital.",
  },
  {
    q: "Faut-il installer une application ?",
    a: "Non. Aucune application n'est nécessaire, ni pour vous ni pour vos clients. La puce NFC ouvre directement la page digitale dans le navigateur du smartphone.",
  },
  {
    q: "Quels sont les prix ?",
    a: "Carte Standard : 40 € TTC. Carte Multi-liens : 45 € TTC. Pack 4 cartes : 80 € TTC. Des packs personnalisés sur mesure sont également disponibles pour les équipes et les établissements. Tous nos prix sont affichés TTC.",
  },
  {
    q: "Quels sont les délais ?",
    a: "Production et livraison sous 7 à 10 jours ouvrés après validation de la commande. Et nous répondons en moins de 30 minutes sur WhatsApp.",
  },
  {
    q: "Comment commander ?",
    a: "Tout se passe sur WhatsApp : cliquez sur « Commander ma carte sur WhatsApp », envoyez-nous votre message, et nous vous accompagnons pas à pas (design, contenu, validation). Réponse sous 30 minutes.",
  },
];

export const FAQ_FULL = [
  {
    category: "La carte et la technologie",
    items: [
      {
        q: "Qu'est-ce que le NFC ?",
        a: "Le NFC (Near Field Communication) est une technologie sans contact intégrée à la quasi-totalité des smartphones récents. En approchant le téléphone à quelques centimètres de la carte, la page digitale s'ouvre automatiquement. Chez Noveocard, le NFC n'est pas le produit : c'est simplement le moyen d'accéder, en un geste, à votre univers digital.",
      },
      {
        q: "Comment fonctionne la carte concrètement ?",
        a: "Votre client approche simplement son smartphone de la carte : la puce NFC ouvre immédiatement une page digitale personnalisée dans son navigateur : vos réseaux sociaux, votre fiche Google Avis, votre numéro, votre menu… Aucune application à installer.",
      },
      {
        q: "La carte fonctionne-t-elle avec un iPhone ?",
        a: "Oui. Tous les iPhone depuis l'iPhone 7 (iOS 11 et plus) lisent le NFC nativement. Sur les modèles récents, il suffit d'approcher le haut du téléphone de la carte.",
      },
      {
        q: "Et avec un téléphone Android ?",
        a: "Oui. La grande majorité des smartphones Android intègrent le NFC (activable dans les paramètres si besoin). Un geste sur la carte suffit.",
      },
      {
        q: "Et si le téléphone n'a pas de NFC ?",
        a: "C'est devenu très rare : la quasi-totalité des smartphones vendus depuis 2015, iPhone comme Android, lisent le NFC nativement. Dans le doute, vos clients peuvent aussi vous retrouver via le lien direct de votre page digitale.",
      },
      {
        q: "Quel est le format et le matériau de la carte ?",
        a: "Uniquement du PVC premium au format carte bancaire : 86 × 54 mm. C'est le format idéal pour un comptoir, une table, une poche ou un porte-cartes. Nous ne proposons aucun autre matériau (ni bois, ni métal, ni papier) : le PVC offre la meilleure durabilité et la meilleure qualité d'impression.",
      },
    ],
  },
  {
    category: "Le contenu digital",
    items: [
      {
        q: "Quels liens puis-je mettre sur ma page digitale ?",
        a: "Google Avis, Instagram, TikTok, WhatsApp, téléphone, site web, menu, adresse, itinéraire, fiche contact, et tout autre lien utile à votre activité.",
      },
      {
        q: "Puis-je mettre plusieurs liens sur une seule carte ?",
        a: "Oui, avec la Carte Multi-liens (45 € TTC) : tous vos liens sont regroupés sur une page digitale élégante, accessible via la même carte. La Carte Standard (40 € TTC) pointe vers un lien unique.",
      },
      {
        q: "Puis-je afficher à la fois Instagram et Google Avis ?",
        a: "Oui, c'est même recommandé. Sur la page digitale multi-liens, vous pouvez mettre en avant votre fiche Google Avis pour récolter plus d'avis, vos réseaux sociaux pour gagner des abonnés, et vos liens de contact.",
      },
      {
        q: "Puis-je modifier mes liens après avoir reçu la carte ?",
        a: "Oui. Le contenu digital (vos liens) peut évoluer sans remplacer la carte : c'est l'un des grands avantages de la carte digitale. Contactez-nous sur WhatsApp pour toute modification, réponse sous 30 minutes.",
      },
      {
        q: "Puis-je mettre un lien direct vers WhatsApp ?",
        a: "Oui. Vos clients peuvent vous écrire sur WhatsApp en un seul geste depuis votre page digitale, ou être dirigés directement vers la conversation.",
      },
    ],
  },
  {
    category: "Personnalisation",
    items: [
      {
        q: "Puis-je mettre mon logo sur la carte ?",
        a: "Oui, c'est le cœur de la personnalisation : logo, nom, couleurs, slogan, identité visuelle. Envoyez votre logo (PNG, JPG ou SVG, fond transparent conseillé) dans la conversation WhatsApp lors de votre commande, et nous préparons un design à votre image.",
      },
      {
        q: "Puis-je choisir n'importe quelle couleur pour ma carte ?",
        a: "Oui, sans aucune restriction : noir, blanc, doré, rouge, vert, rose, bleu, dégradés… Le bleu est la couleur de notre site, jamais une contrainte pour votre carte. Vous choisissez librement dans le configurateur (nuancier complet ou code couleur), et nous dessinons le visuel à partir de vos choix.",
      },
      {
        q: "Le design est-il vraiment personnalisé ?",
        a: "Oui. Votre carte ne se limite pas à un logo sur une couleur : chaque carte est dessinée sur-mesure avec une finition premium (cadre foil, ornements, dégradés, icônes, verso complet). La personnalisation sur-mesure est incluse, et le visuel final est validé avec vous sur WhatsApp avant toute production.",
      },
    ],
  },
  {
    category: "Commande, prix et délais",
    items: [
      {
        q: "Quels sont les prix ?",
        a: "Carte Standard : 40 € TTC (1 carte, 1 lien). Carte Multi-liens : 45 € TTC (1 carte, page digitale multi-liens). Pack 4 cartes : 80 € TTC. Packs personnalisés sur mesure pour équipes et établissements. Tous les prix sont TTC, sans surprise.",
      },
      {
        q: "Comment commander ?",
        a: "Cliquez sur « Commander ma carte sur WhatsApp » : la conversation s'ouvre avec un message déjà préparé. Vous pouvez aussi utiliser notre configurateur pour définir votre activité, votre design et vos liens : votre sélection est automatiquement incluse dans le message. Réponse sous 30 minutes.",
      },
      {
        q: "Comment vous contacter ?",
        a: "Uniquement sur WhatsApp au +33 7 68 22 96 11. C'est notre canal unique, pour vous répondre vite et bien : réponse sous 30 minutes.",
      },
      {
        q: "Quels sont les délais de production et de livraison ?",
        a: "Production et livraison sous 7 à 10 jours ouvrés après validation de la commande (design validé ensemble).",
      },
      {
        q: "Puis-je commander plusieurs cartes ?",
        a: "Oui. Le Pack 4 cartes (80 € TTC) est parfait pour équiper une petite équipe. Pour des volumes plus importants — collaborateurs, plusieurs établissements, restaurants, entreprises — nous créons un pack personnalisé sur mesure : écrivez-nous sur WhatsApp.",
      },
      {
        q: "Faut-il payer en ligne ?",
        a: "Non. Noveocard est un site vitrine : aucune commande ne passe par un panier ou un paiement en ligne. Tout est organisé directement avec vous sur WhatsApp, simplement et en confiance.",
      },
    ],
  },
];
